import { useRoutes } from '@folklore/routes';
import React, { useMemo } from 'react';
import { Route, Switch } from 'wouter';

import useMicromags from '../hooks/useMicromags';

import { MicromagItem } from '../types/micromag';
import MainLayout from './layouts/Main';
import HomePage from './pages/Home';
import MicromagPage from './pages/Micromag';
import TextPage from './pages/Text';

import accessibility from '../data/accessibility.html';
import legal from '../data/legal.html';

interface RoutesProps {
    micromags?: MicromagItem[] | null;
    loading?: boolean;
}

function Routes({ micromags: initialMicromags = null, loading = false }: RoutesProps) {
    const routes = useRoutes() || {};

    const micromags = useMicromags(initialMicromags);

    console.log('micromags', micromags);

    return (
        <Switch>
            <Route path={routes.home}>
                <MainLayout>
                    <HomePage micromags={micromags} />
                </MainLayout>
            </Route>
            <Route path={routes.legal}>
                <MainLayout>
                    <TextPage content={legal} />
                </MainLayout>
            </Route>
            <Route path={routes.accessibility}>
                <MainLayout>
                    <TextPage content={accessibility} />
                </MainLayout>
            </Route>
            <Route path="/:micromag">
                {({ micromag = null }) => {
                    return (
                        <MainLayout fullScreen>
                            <MicromagPage
                                micromags={micromags}
                                micromag={
                                    (micromags || []).find((it) => it.slug === micromag) || null
                                }
                                hasHome
                            />
                        </MainLayout>
                    );
                }}
            </Route>
            <Route path="/:micromag/:screen">
                {({ micromag = null, screen = null }) => (
                    <MainLayout fullScreen>
                        <MicromagPage
                            micromags={micromags}
                            micromag={(micromags || []).find((it) => it.slug === micromag) || null}
                            screen={screen}
                            hasHome
                        />
                    </MainLayout>
                )}
            </Route>
        </Switch>
    );
}

export default Routes;
